import { useDragLayer } from 'react-dnd-latest'
import { Handle } from 'react-flow-renderer'
import FlowBlockPill from './FlowBlockPill'

const layerStyles = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 100,
    left: 100,
    top: 10,
    width: '100%',
    height: '100%',
}
// Position/size only — the visual is the CSS pill (FlowBlockPill) rendered
// inside, so the drag ghost matches the real block instead of a PNG.
function getItemStyles(initialOffset, currentOffset, xOffset, yOffset) {
    if (!initialOffset || !currentOffset) {
        return {
            display: 'none',
        }
    }
    let zoom = JSON.parse(sessionStorage.getItem('planeOffset')) || 1

    if (zoom != 1) zoom = zoom.zoom
    // Match the real block box so the ghost isn't taller/misaligned.
    let height = 42,
        width = 117

    let { x, y } = currentOffset
    x = x - xOffset
    y = y - yOffset

    const transform = `translate(${x}px, ${y}px) scale(${zoom})`
    return {
        height: `${height}px`,
        width: `${width}px`,
        transform,
        WebkitTransform: transform,
    }
}
export const CustomDragLayer = (props) => {
    const { itemType, isDragging, item, initialOffset, currentOffset, delta } =
        useDragLayer((monitor) => ({
            item: monitor.getItem(),
            itemType: monitor.getItemType(),
            initialOffset: monitor.getInitialSourceClientOffset(),
            currentOffset: monitor.getClientOffset(),
            isDragging: monitor.isDragging(),
            delta: monitor.getDifferenceFromInitialOffset(),
        }))
    const myStyle = {
        color: 'white',
        backgroundColor: 'DodgerBlue',
        padding: '10px',
        fontFamily: 'Sans-Serif',
    }
    function renderItem() {
        switch (item.id) {
            case 'if':
                return (
                    <div
                        style={getItemStyles(
                            initialOffset,
                            currentOffset,
                            158,
                            35
                        )}
                        id="dragLayerif"
                    >
                        <FlowBlockPill type="if" className="fcGhost" />
                        <Handle
                            type="target"
                            id="top"
                            position="top"
                            style={{ left: 90, top: 0 }}
                        />
                        <Handle
                            position="left"
                            style={{ left: 140, top: 18 }}
                            id="rYes"
                        />
                        <Handle
                            type="source"
                            position="left"
                            style={{ left: 140, top: 36 }}
                            id="rNo"
                        />
                    </div>
                )
            case 'loop':
                return (
                    <div
                        id="dragLayerloop"
                        style={getItemStyles(
                            initialOffset,
                            currentOffset,
                            158,
                            35
                        )}
                    >
                        <FlowBlockPill type="loop" className="fcGhost" />
                        <Handle
                            type="target"
                            id="top"
                            position="top"
                            style={{ left: 90, top: 0 }}
                        />
                        <Handle
                            type="source"
                            position="right"
                            style={{ left: 140, top: 26 }}
                            id="r"
                        />
                    </div>
                )
            case 'wait':
                return (
                    <div
                        id="dragLayerwait"
                        style={getItemStyles(
                            initialOffset,
                            currentOffset,
                            158,
                            35
                        )}
                    >
                        <FlowBlockPill type="wait" className="fcGhost" />
                        <Handle
                            position="top"
                            id="top"
                            style={{ left: 90, top: 0 }}
                        />
                    </div>
                )
            case 'output':
                return (
                    <div
                        id="dragLayeroutput"
                        style={getItemStyles(
                            initialOffset,
                            currentOffset,
                            158,
                            35
                        )}
                    >
                        <FlowBlockPill type="output" className="fcGhost" />
                        <Handle
                            type="target"
                            position="top"
                            id="top"
                            style={{ left: 90, top: 0 }}
                        />
                    </div>
                )
            case 'end/repeat':
                return (
                    <div
                        id="dragLayerend/repeat"
                        style={getItemStyles(
                            initialOffset,
                            currentOffset,
                            158,
                            35
                        )}
                    >
                        <FlowBlockPill type="end/repeat" className="fcGhost" />
                        <Handle
                            type="target"
                            position="top"
                            id="top"
                            style={{ left: 90, top: 0 }}
                        />
                    </div>
                )
            default:
                return <h1>hello</h1>
        }
    }
    if (!isDragging) {
        return null
    }

    return (
        <div style={layerStyles}>
            <div>{renderItem()}</div>
        </div>
    )
}
